/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Photo_ChangeInputs */

const en_editor_photo_change = /** @type {(inputs: Editor_Photo_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change photo`)
};

const de_editor_photo_change = /** @type {(inputs: Editor_Photo_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto ändern`)
};

/**
* | output |
* | --- |
* | "Change photo" |
*
* @param {Editor_Photo_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_photo_change = /** @type {((inputs?: Editor_Photo_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Photo_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_photo_change(inputs)
	return en_editor_photo_change(inputs)
});